import * as Enumerable from 'linq';

import { Entity, EntityLink } from '../entity';
import { WorkOrderStatusSystemName } from '../job/workorder.status.system.name';
import { Activity } from './activity';
import { ActivityType } from './activity.type';
import { Location } from './location';

export interface ActivityLocation {
    _id: string;
    location: Location;
    links: EntityLink[];
    date: Date;
    contact: Entity;
    status: string;
}

export const allowTrackingLocationTypes = [
    ActivityType.WorkOrderCheckIn,
    ActivityType.WorkOrderCheckout,
    ActivityType.WorkOrderCompleted,
    ActivityType.WorkOrderStop,
    ActivityType.WorkOrderHold,
    ActivityType.WorkOrderEnroute,
    ActivityType.WorkOrderOnsite,
]

export function toActivityLocations(activities: Activity[]): ActivityLocation[] {

    if (!activities?.length)
        return [];

    const type = {
        [ActivityType.WorkOrderCheckout]: WorkOrderStatusSystemName.CheckedOut,
        [ActivityType.WorkOrderOnsite]: WorkOrderStatusSystemName.Onsite,
        [ActivityType.WorkOrderEnroute]: WorkOrderStatusSystemName.Enroute,
        [ActivityType.WorkOrderCompleted]: WorkOrderStatusSystemName.Completed,
        [ActivityType.WorkOrderHold]: WorkOrderStatusSystemName.OnHold,
    }

    const locations = Enumerable.from(activities)
        .where(x => !!x?._id)
        .select(a => {

            const location: ActivityLocation = {
                _id: a._id,
                contact: a.createdBy,
                date: a.createdDate,
                location: a.location,
                links: a.links,
                status: type[a.type],
            }

            return location;

        }).toArray();


    return locations;

}
